document.addEventListener("DOMContentLoaded", function () {
  const dateInput = document.getElementById("cart-delivery-date");
  const timeInput = document.getElementById("cart-delivery-time");
  const checkoutButton = document.querySelector('[name="checkout"]');
  const form = document.querySelector("form.cart");

  if (!dateInput || !timeInput || !checkoutButton || !form) return;

  const cutoffHour = 16;
  const launchDate = new Date(2026, 3, 20); // 20.04.2026
  const timeStartHour = 10;
  const timeEndHour = 18;

  function normalizeDate(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function formatDateLocal(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }

  function parseDateLocal(value) {
    if (!value) return null;
    const parts = value.split("-");
    if (parts.length !== 3) return null;

    return new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );
  }

  function isSunday(date) {
    return date.getDay() === 0;
  }

  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function getEarliestDeliveryDate() {
    const now = new Date();
    let minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    if (now.getHours() < cutoffHour) {
      minDate = addDays(minDate, 1);
    } else {
      minDate = addDays(minDate, 2);
    }

    if (minDate < launchDate) {
      minDate = new Date(launchDate);
    }

    while (isSunday(minDate)) {
      minDate = addDays(minDate, 1);
    }

    return normalizeDate(minDate);
  }

  function getNextValidDate(date) {
    let d = normalizeDate(date);
    const minDate = getEarliestDeliveryDate();

    if (d < minDate) {
      d = new Date(minDate);
    }

    while (isSunday(d)) {
      d = addDays(d, 1);
    }

    return normalizeDate(d);
  }

  function buildTimeOptions() {
    const currentValue = timeInput.value;
    timeInput.innerHTML = '<option value="">Bitte wählen</option>';

    for (let hour = timeStartHour; hour <= timeEndHour; hour++) {
      const value = `${String(hour).padStart(2, "0")}:00`;
      const option = document.createElement("option");
      option.value = value;
      option.textContent = `${value} Uhr`;
      timeInput.appendChild(option);
    }

    const valueStillExists = Array.from(timeInput.options).some(function (option) {
      return option.value === currentValue;
    });

    timeInput.value = valueStillExists ? currentValue : "";
  }

  function applyDateRules() {
    const minDate = getEarliestDeliveryDate();
    dateInput.min = formatDateLocal(minDate);

    if (!dateInput.value) return;

    const selectedDate = parseDateLocal(dateInput.value);
    if (!selectedDate) {
      dateInput.value = "";
      return;
    }

    const correctedDate = getNextValidDate(selectedDate);

    if (formatDateLocal(selectedDate) !== formatDateLocal(correctedDate)) {
      dateInput.value = formatDateLocal(correctedDate);
    }
  }

  function updateCheckoutState() {
    const enabled = !!dateInput.value && !!timeInput.value;

    checkoutButton.disabled = !enabled;
    checkoutButton.style.opacity = enabled ? "1" : "0.5";
    checkoutButton.style.pointerEvents = enabled ? "auto" : "none";
    checkoutButton.style.cursor = enabled ? "pointer" : "not-allowed";
  }

  function prefillFromLocalStorage() {
    const storedDate = localStorage.getItem("delivery_date");
    const storedTime = localStorage.getItem("delivery_time");

    if (storedDate && !dateInput.value) {
      dateInput.value = storedDate;
    }

    if (storedTime && !timeInput.value) {
      timeInput.value = storedTime;
    }
  }

  async function syncCartAttributes() {
    const payload = {
      attributes: {
        Lieferdatum: dateInput.value || "",
        Lieferzeit: timeInput.value || ""
      }
    };

    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error("Cart-Attribute konnten nicht gespeichert werden.");
    }

    return response.json();
  }

  async function refreshAll() {
    buildTimeOptions();
    prefillFromLocalStorage();
    applyDateRules();
    updateCheckoutState();

    if (dateInput.value || timeInput.value) {
      try {
        await syncCartAttributes();
      } catch (error) {
        console.error(error);
      }
    }
  }

  function validateBeforeSubmit(event) {
    const submitter = event.submitter || document.activeElement;

    if (!submitter || submitter.name !== "checkout") {
      return;
    }

    applyDateRules();
    updateCheckoutState();

    if (!dateInput.value || !timeInput.value) {
      event.preventDefault();
      alert("Bitte wählen Sie ein Wunsch-Lieferdatum und eine Uhrzeit aus.");
      if (!dateInput.value) {
        dateInput.focus();
      } else {
        timeInput.focus();
      }
      return;
    }

    const selectedDate = parseDateLocal(dateInput.value);
    const minDate = getEarliestDeliveryDate();

    if (!selectedDate || selectedDate < minDate || isSunday(selectedDate)) {
      event.preventDefault();
      dateInput.value = formatDateLocal(getNextValidDate(selectedDate || minDate));
      updateCheckoutState();
      alert("Bitte wählen Sie ein gültiges Lieferdatum aus.");
      dateInput.focus();
      return;
    }

    const validTimes = Array.from(timeInput.options).map(function (option) {
      return option.value;
    });

    if (!validTimes.includes(timeInput.value) || timeInput.value === "") {
      event.preventDefault();
      timeInput.value = "";
      updateCheckoutState();
      alert("Bitte wählen Sie eine gültige Uhrzeit aus.");
      timeInput.focus();
    }
  }

  refreshAll();

  dateInput.addEventListener("focus", refreshAll);

  dateInput.addEventListener("change", async function () {
    applyDateRules();
    updateCheckoutState();
    localStorage.setItem("delivery_date", dateInput.value || "");
    try {
      await syncCartAttributes();
    } catch (error) {
      console.error(error);
    }
  });

  dateInput.addEventListener("input", function () {
    applyDateRules();
    updateCheckoutState();
  });

  timeInput.addEventListener("change", async function () {
    updateCheckoutState();
    localStorage.setItem("delivery_time", timeInput.value || "");
    try {
      await syncCartAttributes();
    } catch (error) {
      console.error(error);
    }
  });

  form.addEventListener("submit", validateBeforeSubmit);
});